<template lang="html">
  <div class="container">

    <div class="header">

      <p class="select">
        {{filterdata.begin_time}}-{{filterdata.end_time}},{{department[filterdata.group]}}
        <i class="icon iconfont icon-shaixuan" @click="filter"></i>
      </p>
      <div class="list">

        <p class="table1 borb " @click="toDrill(1)">
          <span class="col">
            <span class="small">¥</span>
            {{data.pay_back == undefined ? '' : (data.pay_back/10000).toFixed(2)}}
            <span class="small">(万)</span>
          </span>
          <span class="col1">已回款</span>
        </p>

        <p class="table1 borb borl" @click="toDrill(5)">
           <span class="col">
            <span class="small">¥</span>
            {{ data.y_pay_invoice == undefined ? '' : (data.y_pay_invoice/10000).toFixed(2) }}
            <span class="small">(万)</span>
          </span>
          <span class="col1">已开发票待回款</span>
        </p>

        <div class="table1 borb" @click="toDrill(6)">
          <p class="col">
            <!-- <span class="small" v-if="filterdata.timeId != 1">¥</span> -->
            {{data.p_complete}}
            <!-- <span class="small" v-if="filterdata.timeId != 1">(万)</span> -->
          </p>
          <span class="col1">已交付项目数</span>
        </div>

        <div class="table1 borl borb"  @click="toDrill(2)">
          <p class="col">
            <!-- <span class="small" v-if="filterdata.timeId != 1">¥</span> -->
            {{ data.p_count}}
            <!-- <span class="small" v-if="filterdata.timeId != 1">(万)</span> -->
          </p>
          <span class="col1">新增项目数</span>
        </div>


        <p class="table1 borb">
          <span class="col">
            {{data.n_p_count}}
          </span>
          <span class="col1" style="color:#666;">计划交付项目数</span>
        </p>

        <p class="table1 borb borl" @click="toDrill(3)">
          <span class="col">
            {{data.p_delivery }}
          </span>
          <span class="col1">需交付项目数</span>
        </p>

        <div class="table1">
          <span class="col">{{ data.p_pre }}%</span>
          <span class="col1" style="color:#666;">整体交付率</span>
        </div>

        <div class="table1 borl" @click="toDrill(4)">
          <p class="col">
            {{data.p_doing }}
          </p>
          <span class="col1">正在开发项目数</span>
        </div>

      </div>
    </div>

    <div class="percent1">
      <p class="test">
        各制作部{{filterdata.begin_time}}-{{filterdata.end_time}}交付金额占比(万)
      </p>
      <div style="height:8.5rem;">
        <IEcharts :option="pie" @click="showDetail($event,2)"></IEcharts>
      </div>

    </div>

    <div class="percent1">
      <p class="test">
        各制作部{{filterdata.begin_time}}-{{filterdata.end_time}}项目回款金额占比(万)
      </p>
      <div style="height:8.5rem;">
        <IEcharts :option="pie2"  @click="showDetail($event,1)"></IEcharts>
      </div>
    </div>


    <div  class="zhezhao" v-if="isFilter" @click="cancel"></div>

    <div  class="selbox" v-if="isFilter"><p >筛选</p>

      <p  class="content">
        时间
      </p>
      <ul  class="listtime">
        <mt-picker :slots="slots" @change="onDateChange" valueKey="name" class="inner-picker" :visibleItemCount="3"></mt-picker>
      </ul>


      <p  class="content">
        制作部
      </p>
      <ul  class="listtime">
        <li  :class="{'true': c_department[0] == index }" v-for="(item,index) in department" @click="onDepartmentChang(index)">{{item}}</li>
      </ul>


      <p  class="btnyes" @click="confirmFilter">确定</p>
    </div>

  </div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/lite.js'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'

import slotsList from '../assets/js/slotsList'
import dateChange from '../mixins/dateChange.js'
import groupChange from '../mixins/groupChange.js'

import '../assets/css/filterModal.css'
import { getMonthRanges } from '../assets/js/date'

import Vue from 'vue'
export default {
  mixins: [dateChange, groupChange],
  components: {
    IEcharts
  },
  data() {
    return {
      data: [],
      isFilter: false,

      filterdata: {
        begin_time: null,
        end_time: null,
        group: [0],
      },

      slots: slotsList.Monthslots(),

      pie: {
        // color: ['#6DB0FB','#EC7A8A','#FAE35A','#D185FF','#FFA761','#FFA761'],
        legend: {
          width: '90%',
          orient: 'horizontal',
          bottom: '1%',
          icon: 'circle',
          data: ['制作一部', '制作二部', '制作三部', '制作四部', '制作五部'],
          itemGap: 20,
          textStyle: {
            fontSize: 12,
            color: '#333',
          }
        },
        title: [{
          text: '交付总金额',
          x: '49%',
          y: '35%',
          textAlign: 'center',
          textStyle: {
            color: '#333',
            fontSize: '12',
            fontWeight: '400',
          }
        },
        {
          text: '206',
          x: '49%',
          y: '42%',
          textAlign: 'center',
          textStyle: {
            color: '#333',
            fontSize: '12',
            fontWeight: '400',
          }
        }],
        series: [{
          center: ['50%', '42%'],
          color: ['#6DB0FB', '#FAE35A', '#86E687', '#FFA761', '#D185FF', '#EC7A8A'],
          hoverAnimation: false, //设置饼图默认的展开样式
          radius: [40, 60],
          name: 'pie',
          type: 'pie',
          selectedMode: 'single',
          selectedOffset: 6, //选中是扇区偏移量
          clockwise: true,
          startAngle: 90,
          //  data: [{value:100,name:'三亚'},{value:100,name:'成都'}],
          data: [],
          label: {
            normal: {
              show: true,
              position: 'outside',
              formatter: "{d}%\n{b} {c}万",
              textStyle: {
                fontSize: 10,
              }
            }
          }
        }]
      }, //各制作部交付金额占比

      pie2: {
        legend: {
          width: '90%',
          orient: 'horizontal',
          bottom: '1%',
          icon: 'circle',
          data: ['制作一部', '制作二部', '制作三部', '制作四部', '制作五部'],
          itemGap: 20,
          textStyle: {
            fontSize: 12,
            color: '#333',
          }
        },
        title: [{
          text: '回款总金额',
          x: '49%',
          y: '35%',
          textAlign: 'center',
          textStyle: {
            color: '#333',
            fontSize: '12',
            fontWeight: '400',
          }
        },
        {
          text: '206',
          x: '49%',
          y: '42%',
          textAlign: 'center',
          textStyle: {
            color: '#333',
            fontSize: '12',
            fontWeight: '400',
          }
        }],
        series: [{
          center: ['50%', '42%'],
          color: ['#6DB0FB', '#FAE35A', '#86E687', '#FFA761', '#D185FF', '#EC7A8A'],
          hoverAnimation: false, //设置饼图默认的展开样式
          radius: [40, 60],
          name: 'pie',
          type: 'pie',
          selectedMode: 'single',
          selectedOffset: 6, //选中是扇区偏移量
          clockwise: true,
          startAngle: 90,
          //  data: [{value:100,name:'三亚'},{value:100,name:'成都'}],
          data: [],
          label: {
            normal: {
              show: true,
              position: 'outside',
              formatter: "{d}%\n{b} {c}万",
              textStyle: {
                fontSize: 10,
              }
            }
          }
        }]
      }
    }
  },
  methods: {
    filter() { //显示过滤页
      this.slots = slotsList.Monthslots(this.filterdata.begin_time, this.filterdata.end_time)
      this.isFilter = true
      this.$emit('inFilter')
    },

    cancel() {
      this.isFilter = false
      this.c_department = this.filterdata.group
      this.$emit('noFilter')
    },

    confirmFilter() {
      this.filterdata = {
        begin_time: this.c_begin_time,
        end_time: this.c_end_time,
        group: this.c_department,
      }
      // let data = {date:this.filterdata.timeId,group:this.filterdata.departmentId}
      this.isFilter = false
      this.$emit('noFilter')
      this.$notice.loading()
      this.getData(this.filterdata)
    },

    toDrill(type) {
      switch (type) {
        case 1: //已回款
          this.toBackDrill(this.filterdata)
          break;
        case 5: //已开发票待回款
          this.toHasInReturnBack(this.filterdata)
          break;
        default:
          // 2:新增项目数 3:需交付项目数 4:正在开发项目数 6:已交付项目数
          this.toSomeDrill(this.filterdata, type)
          break;

      }
    },

    showDetail(event, type) { // echarts =》 钻取页
      let data = {
        begin_time: this.filterdata.begin_time,
        end_time: this.filterdata.end_time,
        group: [],
        origin_group: this.filterdata.group
      }
      data.group.push(this.findDepartmentID(event.name))
      // 1:签约金额占比
      switch (type) {
        case 1:
          this.toBackDrill(data)
          break;
        case 2:
          this.toDeliverDrill(data)
          break;
      }
    },

    toBackDrill(data) { //已回款 回款总金额占比
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'mbmdrill' })
    },

    toHasInReturnBack(data) { //已开发票待回款
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'mhirmdrill' })
    },

    toSomeDrill(data, type) { // 新增项目数 需交付项目数 正在开发项目数
      data.type = type
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'msdrill' })
    },

    toDeliverDrill(data) { //交付总金额占比
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'mddrill' })
    },

    getData(data) { //获取主要数据
      this.$notice.loading()
      this.$http.getMake(data).then(res => {
        let obj = res.data.group_data
        let department = { 0: '全部' }
        for (var key in obj) {
          department[key] = obj[key]
        }
        this.department = department
        this.data = res.data
        this.$notice.loading(false)
      })

      this.$http.getMakeChartsData(data).then(res => {
        this.pie.series[0].data = res.data.t_money
        this.pie.title[1].text = res.data.all_money
        this.pie2.series[0].data = res.data.b_money
        this.pie2.title[1].text = res.data.all_back_money
      })
    },
  },
  created() {
   

    if (!window.localStorage.getItem('drillData')) {
      
       this.filterdata.begin_time = getMonthRanges().begin_time
      this.filterdata.end_time = getMonthRanges().end_time
      this.slots = slotsList.Monthslots()
    } else {
      let data = JSON.parse(window.localStorage.getItem('drillData'))
      this.filterdata.begin_time = data.begin_time
      this.filterdata.end_time = data.end_time
      this.filterdata.group = this.c_department = data.origin_group || data.group

      this.slots = slotsList.Monthslots(this.begin_time, this.end_time)
    }

    this.getData(this.filterdata)
  },
}
</script>

<style lang="css" scoped>
.container {
  width: 100%;
  background-color: #fafafa;
}
.header {
  width: 100%;
  background: #f5f5f5;
  padding-top: 0.15625rem;
  margin-bottom: 0.21875rem;
}
.header .icon {
  font-size: 0.5rem;
  position: absolute;
  right: 0.5rem;
  top: 0;
  margin: auto;
}
.select {
  width: 100%;
  color: #fff;
  height: 1.1875rem;
  background: #5483d2;
  font-size: 0.4375rem;
  line-height: 1.1875rem;
  padding-left: 0.34375rem;
  margin-bottom: 0.1875rem;
  position: relative;
  clear: both;
}
.list {
  width: 100%;
  margin: auto;
  color: #000;
  height: 11.25rem;
  border: 0;
  background: #fff;
}
.rank {
  color: #000;
  height: 10.44375rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.1875rem;
}
.percent1 {
  color: #000;
  height: 9.125rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.1875rem;
}
.test {
  border-left: 0.0625rem solid #5483d2;
  width: 100%;
  /*position: absolute;*/
  right: 0;
  top: 0.34375rem;
  font-size: 0.375rem;
  color: #333333;
  font-family: PingFangSC-Regular;
  padding-left: 2%;
  font-weight: 500;
  height: 0.625rem;
  line-height: 0.625rem;
}
.test span {
  position: absolute;
  right: 5%;
  font-family: PingFangSC-Regular;
  color: rgba(153, 153, 153, 1);
  font-size: 0.375rem;
}
.table1 {
  width: 50%;
  float: left;
  height: 2.8125rem;
  text-align: center;
  padding-top: 0.6875rem;
}
.borb {
  border-bottom: 1px solid #ddd;
}
.borl {
  border-left: 1px solid #ddd;
}

.col {
  font-size: 0.625rem;
  color: #333333;
  font-family: PingFangSC-Regular;
  display: block;
}
.col1 {
  font-size: 0.375rem;
  color: #5483d2;
  font-family: PingFangSC-Regular;
}
.small {
  color: #333333;
  font-size: 0.375rem;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Make.vue